export default class CFOP {
  constructor(id, codigo, descricao, auditar) {
    this.id = id
    this.codigo = codigo
    this.descricao = descricao
    this.auditar = auditar
  }
}
